import { z } from "zod";
import { uppercaseUlidSchema } from "./billing";
const timestampSchema = z.number().int().min(0).max(Number.MAX_SAFE_INTEGER);
const cursorSchema = z
    .string()
    .regex(/^[A-Za-z0-9_-]+$/)
    .min(1)
    .max(256);
const emailSchema = z.string().trim().toLowerCase().pipe(z.email().max(320));
export const supportPublicCategorySchema = z.enum([
    "account_access",
    "billing",
    "privacy",
    "technical",
    "other",
]);
export const supportCategorySchema = z.enum([
    "refund_request",
    ...supportPublicCategorySchema.options,
]);
export const supportStatusSchema = z.enum(["open", "resolved", "spam", "closed"]);
export const publicSupportStatusSchema = z.enum(["open", "resolved", "closed"]);
export const supportSubjectSchema = z.string().trim().min(1).max(200);
export const supportMessageSchema = z.string().trim().min(10).max(4_000);
export const supportIdempotencyKeySchema = z
    .string()
    .trim()
    .min(8)
    .max(128)
    .regex(/^[!-~]+$/);
export const supportProofTokenSchema = z.string().trim().min(32).max(256);
export const supportRequestSummarySchema = z.strictObject({
    id: uppercaseUlidSchema,
    category: supportCategorySchema,
    subject: supportSubjectSchema,
    status: publicSupportStatusSchema,
    createdAt: timestampSchema,
    resolvedAt: timestampSchema.nullable(),
    paymentOrderId: uppercaseUlidSchema.nullable().optional(),
});
export const supportStatusResponseSchema = z.strictObject({
    authenticated: z.boolean(),
    contactOptions: z.strictObject({
        categories: z
            .array(supportPublicCategorySchema)
            .length(supportPublicCategorySchema.options.length),
        challengeRequired: z.boolean(),
        supportEmail: emailSchema.optional(),
    }),
    myRequests: z.array(supportRequestSummarySchema).max(50),
});
export const supportChallengeRequestInputSchema = z.strictObject({
    email: emailSchema,
    locale: z.enum(["id", "en"]).default("id"),
});
export const supportChallengeRequestResponseSchema = z.strictObject({
    accepted: z.literal(true),
});
export const supportChallengeVerifyInputSchema = z.strictObject({
    email: emailSchema,
    token: supportProofTokenSchema,
});
export const supportChallengeVerifyResponseSchema = z.strictObject({
    proofToken: supportProofTokenSchema,
    expiresAt: timestampSchema,
});
export const supportContactInputSchema = z.strictObject({
    category: supportPublicCategorySchema,
    subject: supportSubjectSchema,
    message: supportMessageSchema,
    idempotencyKey: supportIdempotencyKeySchema,
    proofToken: supportProofTokenSchema.optional(),
});
export const supportContactResponseSchema = z.strictObject({
    request: supportRequestSummarySchema,
    replay: z.boolean(),
});
export const adminSupportListQuerySchema = z.strictObject({
    status: supportStatusSchema.optional(),
    category: supportCategorySchema.optional(),
    cursor: cursorSchema.optional(),
    limit: z.coerce.number().int().min(1).max(50).default(20),
});
export const adminSupportRequestSchema = z.strictObject({
    id: uppercaseUlidSchema,
    category: supportCategorySchema,
    subject: supportSubjectSchema,
    message: z.string().min(1).max(4_000),
    status: supportStatusSchema,
    createdAt: timestampSchema,
    resolvedAt: timestampSchema.nullable(),
    userId: z.string().min(1).max(128).nullable(),
    ownerId: z.string().min(1).max(128).nullable(),
    email: emailSchema.nullable(),
    paymentOrderId: uppercaseUlidSchema.nullable(),
});
export const adminSupportListResponseSchema = z.strictObject({
    items: z.array(adminSupportRequestSchema.omit({ message: true })).max(50),
    nextCursor: cursorSchema.optional(),
});
export const adminSupportDetailResponseSchema = z.strictObject({
    request: adminSupportRequestSchema,
});
export const adminSupportActionInputSchema = z.strictObject({
    reason: z.string().trim().min(8).max(1_000),
});
export const adminSupportActionResponseSchema = z.strictObject({
    request: adminSupportRequestSchema,
});
//# sourceMappingURL=support.js.map